export default __webpack_public_path__ + "static/media/q1_step1_4.1b8aaf57.png";